const helpers = {
    getFilename: (file) => {
        if (!file) {
            return false;
        }
        return file.replace(/^.*[\\\/]/, '');
    },
    getThousandCommaNumber: (number) => {
        return number.toLocaleString('de-DE');
    },
    isValidEmail: (e) => {
        // eslint-disable-next-line
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(e);
    }
};

export default helpers;


// WEBPACK FOOTER //
// ./src/utils/helpers.js